// @vendors
import { useEffect, useState, useContext } from "react"
import { Form, Select, Modal, ConfigProvider } from 'antd'
import Context from '../../../context/appContext';
import { getUrl, getDependencyValue } from '../../../utils/utils';


export default function SelectField({ info, key, form, current }) {

    const [values, setValues] = useState(info.data.values ? info.data.values : []);
    const validate = info.validate ? info.validate : {};
    const { customRequest, dataForm: { data, formResponses, hiddenFields, disabledFields }, checkOption, disabledOption, setDataForm } = useContext(Context);
    const [disabled, setDisabled] = useState(false);
    const [selectParentesco, setSelectParentesco] = useState(false);
    const selectKeys = {
        // estadoContratante: true,
        coloniaContratante: true,
        ciudadContratante: true,
        municipioContratante: true,
        estadoAsegurado: true,
        coloniaAsegurado: true,
        ciudadAsegurado: true,
        municipioAsegurado: true
    };

    const keyDisabledFields = {
        estadoAsegurado: true,
    }

    useEffect(async () => {
        const sfield = selectKeys[info.key] ? validadateSelect() : true;
        if (info && sfield) {
            await (info.customDefaultValue || form.getFieldValue(info.key) || info.value) && getValues();
            getDefaultValue();
        }
    }, []);

    useEffect(async () => {
        const sfield = selectKeys[info.key] ? validadateSelect() : true;
        if (disabledFields[info.key] && sfield) {
            await (info && (info.customDefaultValue || form.getFieldValue(info.key) || info.value)) && getValues();
            getDefaultValue();
        }
    }, [disabledFields[info.key]]);


    const validadateSelect = () => {
        const codPostal = formResponses.find(x => x.key === "codigoPostalAsegurado");
        return codPostal && codPostal.value && codPostal.value !== '';
    }

    const getValues = async () => {
        const index = formResponses.findIndex(x => x.key === info.key);
        if (info && info.value && info.valuesResponse && info.valuesResponse.length > 0) {
            setValues(info.valuesResponse);
        } else if ((!values[0] || (values[0] && values[0].value !== 'Cargando')) && info.dataSrc && info.dataSrc === "json") {
        const dataLcl = JSON.stringify(info.data.json);
        const opciones_servicio = getUrl(dataLcl, formResponses);
        setValues([{ label: 'Cargando...', value: 'Cargando', disabled: true }]);
        const response = opciones_servicio && opciones_servicio.url && await customRequest(opciones_servicio.url, opciones_servicio.headers,
            opciones_servicio.method, opciones_servicio.body);

        if (response && response.success === false) {
            configModal("Lo sentimos, de momento no contamos con cobertura en tu localidad.", 'Aceptar', 'Ops!')
        }
        const valuesResponse = response && response.length ? response :
            response && response.data && response.data.length ? response.data : [];
        info.valuesResponse = valuesResponse;
        index !== -1 ? formResponses[index].valuesResponse = valuesResponse : formResponses.push(info);
        setValues(response && !response.message ? valuesResponse : []);
    }
}

    const configModal = (message, btnOk, title) => {
        Modal.info({
            icon: '',
            title: title,
            className: 'modal-confirm',
            closable: false,
            okButtonProps: {
                className: 'ant-btn-solid c-2 ant-btn-size-xs margin-s'
            },
            okText: btnOk,
            content: <p>{message}</p>,
            onOk() { }
        });
    }

    const onChange = (event) => {
        if (values.length === 0) {
            setValues([{ label: 'Cargando...', value: 'Cargando', disabled: true }]);
        }
        setValue(event);
        const dependencyValue = getDependencyValue(current, info.key, event, []);
        if (dependencyValue && dependencyValue.length > 0) {
            dependencyValue.forEach(item => {
                const keyLcl = Object.keys(item)[0];
                form.setFieldsValue({ [keyLcl]: '' });
                hiddenFields[keyLcl] = item[keyLcl];
            });
            setDataForm({ data, formResponses, hiddenFields: hiddenFields, disabledFields });
        }
    }

    const setValue = (value) => {
        info.value = value;
        if(info.key==='estadoAsegurado'){
            const index = formResponses.findIndex(x => x.key === 'copyestadoAsegurado');
            index != -1 ? formResponses[index].value = value : formResponses.push({...info,key:'copyestadoAsegurado'});
        }
        const index = formResponses.findIndex(x => x.key === info.key);
        index != -1 ? formResponses[index].value = value : formResponses.push(info);
    }

    const getDefaultValue = async () => {
        const chkData = formResponses.find((item) => item.key === "datosContratanteIgualAsegurado");
        const hasCheckLoadLastStepInfo = current.newItems.find(x => x && x.key === "datosContratanteIgualAsegurado");

        let value = '';
        if (info.customDefaultValue && (!hasCheckLoadLastStepInfo || (hasCheckLoadLastStepInfo && chkData && chkData.value))) {
            const item = formResponses.find((x) => x.key === info.customDefaultValue);
            value = item && item.value ? item.value : '';
            disabledFields[info.key] = value && keyDisabledFields && !keyDisabledFields[info.key];
        } else if (info && info.value && info.value !== null && info.value !== '') {
            value = info.value;
        }

        if (value && value !== '') {
            form.setFieldsValue({ [info.key]: value });
            onChange(value);
        }
    }

    return (
        <div
            id={info.key}
            style={{ position: 'relative', display: hiddenFields[info.key] ? 'none' : 'block' }}
        >
            <Form.Item
                label={info.label}
                name={info.key}
                rules={[
                    {
                        required: hiddenFields[info.key] || disabledFields[info.key] || disabled ? false : validate.required,
                        message: 'Este campo es requerido'
                    }
                ]}
            >

                <Select
                    showSearch
                    placeholder={info.placeholder}
                    notFoundContent={"No se encontraron coincidencias"}
                    disabled={disabledFields[info.key]}
                    onChange={onChange}
                    onFocus={getValues}
                    key={key}
                    getPopupContainer={() => document.getElementById(info.key)}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    {values && values.length > 0 && values.map((item) => (
                        <Select.Option
                            value={item.clave || item.key}
                            key={item.clave || item.key || item.value}
                            disabled={item.disabled || (disabledOption && item.value === 'C')}
                        >
                            {item.descripcion || item.description || item.label}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            {info && info.description && (<div className="ant-select-description">{info.description}</div>)}
        </div>
    )
}